// Fallback team data — only rendered if the live members API is unreachable.
// (GET /public/landing-page/sevensevensix/members). See useTeamMembers.ts.
// Photos use local repo assets; members without a local asset have no image.
// Generated from the live API to stay in sync with the current roster.
import AlexisOhanian from "assets/images/team/Alexis-Ohanian.png";
import KatelinHolloway from "assets/images/team/Katelin-Holloway.png";
import ChrisVanzetta from "assets/images/team/Chris-Vanzetta.png";
import HarryChiang from "assets/images/team/Harry-Chiang.png";
import MarlonPrimous from "assets/images/team/Marlon-Primous.png";
import MichaelCho from "assets/images/team/Michael-Cho.png";
import KenyNguyen from "assets/images/team/Keny-Nguyen.png";
import MaggiComeaux from "assets/images/team/Maggi-Comeaux.png";
import NefitieriMoncur from "assets/images/team/Nefitieri-Moncur.png";
import SarahBoles from "assets/images/team/Sarah-Boles.png";
import AshShemirani from "assets/images/team/Ash-Shemirani.png";
import { TeamCard } from ".";

const data: TeamCard[] = [
  {
    id: "1",
    name: "Alexis Ohanian",
    position: "General Partner, Founder",
    image: AlexisOhanian,
    text: "In 2020, Alexis founded Seven Seven Six, an early stage venture capital firm with over $1.4B AUM. At its heart, the firm is a technology company that deploys venture capital. Two years later, he launched his family foundation 776.org to combat inequity worldwide through entrepreneurship and announced a $20M commitment to climate action through his new 776 Climate Fellowship. He also wrote a national bestselling book, Without Their Permission, for which he embarked on a 5-month bus tour speaking at 82 universities across America about innovation. He was a partner at Y Combinator and a co-founder of Initialized Capital. Prior to that, in 2005, he co-founded Reddit. He departed in 2010, only to return as executive chairman in 2014 to help lead the turnaround of what is now one of the largest websites in the U.S. and listed on the NYSE as $RDDT.",
    socials: {
      twitter: "https://twitter.com/alexisohanian",
      instagram: "https://instagram.com/alexisohanian",
      linkedin: "https://www.linkedin.com/in/alexisohanian/",
      tiktok: "https://tiktok.com/@alexisohanian",
      web: "http://alexisohanian.com",
    },
  },
  {
    id: "2",
    name: "Katelin Holloway",
    position: "Founding Partner",
    image: KatelinHolloway,
    text: "As Founding Partner, Katelin actively invests across various sectors, oversees all firm and portfolio operations, and leads investor relations. Katelin has a unique perspective on the intersection of people and technology. She brings over 15 years of executive and operating experience to the world of venture, having spent significant time at some of this generation\u2019s most influential technology companies like Pixar Animation Studios, Klout, and Reddit. Leveraging her expertise in HR, operations, and culture building, Katelin is focused on driving outsized returns with care. As an investor, she is passionate about funding and coaching the people-first companies that will shape the future of work, life, sustainability, and the delicate balance that enables us to thrive.",
    socials: {
      twitter: "https://twitter.com/katelin_cruse",
      instagram: "https://instagram.com/katelin_cruse",
      linkedin: "https://www.linkedin.com/in/katelinholloway/",
      web: "https://www.katelinholloway.com/",
    },
  },
  {
    id: "3",
    name: "Chris Vanzetta",
    position: "Partner",
    image: ChrisVanzetta,
    text: "Chris brings over a decade of experience as an HR leader working at hyper-growth technology companies and Fortune 50 organizations to Seven Seven Six. In addition to his budding investor career, he also leads firm operations, manages our incubation program, and supports our portfolio companies on recruiting, HR, culture, and workforce strategies. Prior to joining the firm, Chris was the Global Head of HR at Reddit. He\u2019s interested in funding companies that focus on wellness and well-being, both inside and out of the workplace.",
    socials: {
      twitter: "https://twitter.com/vanzetta_chris",
      linkedin: "https://www.linkedin.com/in/christopher-vanzetta-99209712b/",
    },
  },
  {
    id: "4",
    name: "Harry Chiang",
    position: "Outcomes Manager",
    image: HarryChiang,
    text: "Harry manages our Portfolio Outcomes team, working on everything from due diligence, founder support, incubations, fundraising, building internal functions, product, and more. He has worked closely with the partners on every new investment the firm has made since joining in 2021. He was in investment banking covering consumer before joining the Seven Seven Six team.",
    socials: {
      twitter: "https://twitter.com/harryxchiang",
      linkedin: "https://www.linkedin.com/in/harryxchiang/",
    },
  },
  {
    id: "5",
    name: "Marlon Primous",
    position: "Outcomes Associate",
    image: MarlonPrimous,
    text: "As an associate, Marlon does due diligence on prospective investments while supporting our portfolio company\u2019s founders with their financial infrastructure. He previously was a senior manager of finance at Buzzer Technologies and an investment banking analyst at Morgan Stanley. His acute understanding of early-stage companies is underscored by his status as a guest lecturer at Kellogg School of Business and a former VC scout for Concrete Rose Capital.",
    socials: {
      twitter: "https://twitter.com/OptimusPrimous",
      linkedin: "https://www.linkedin.com/in/marlon-primous-84633311b/",
    },
  },
  {
    id: "7",
    name: "Michael Cho",
    position: "Head of Finance & Compliance",
    image: MichaelCho,
    text: "Michael manages the financial strategy and regulatory compliance efforts, overseeing budgeting, financial reporting, and risk management. Before joining Seven Seven Six, Michael was a research analyst at Osmium Partners, a long/short hedge fund specializing in small-cap equities. He brings over a decade of experience working in investment management.",
    socials: {
      linkedin: "https://www.linkedin.com/in/michaelch0/",
    },
  },
  {
    id: "8",
    name: "Keny Nguyen",
    position: "Finance Manager",
    image: KenyNguyen,
    text: "As part of the Finance team, Keny plays a key role in managing the financial strategy and regulatory compliance efforts, overseeing budgeting, financial reporting, and risk management. Prior to joining Seven Seven Six, he started his career at PwC providing assurance services to various tech, life science, and venture capital clients in the Bay Area, and was most recently a Finance Manager at Venrock, a venture firm based in Palo Alto.",
    socials: {},
  },
  {
    id: "9",
    name: "Elizabeth Gray",
    position: "Finance Manager",
    text: "As part of the Finance Team, Elizabeth plays a pivotal role in leading the firm\u2019s internal financial strategy and operations, with a focus on budgeting, compliance, incubations, and cross-functional planning.\r\n\r\nBefore joining Seven Seven Six, Elizabeth began her career at PwC, where she delivered assurance services to a diverse portfolio of venture capital, private equity, and mutual fund clients across the Bay Area. Most recently, she was part of the finance team at GV, Alphabet\u2019s venture capital arm.",
    socials: {},
  },
  {
    id: "10",
    name: "Asif Ahmed",
    position: "Lead Software/Design Engineer",
    text: "Asif drives development of the firm's platform, Cerebro, the operating system that powers Seven Seven Six. A product engineer at heart, he turns strategic ideas into intuitive tools, surfacing the right data and automating routine workflows so founders, investors, and teammates can move faster and make smarter decisions. \r\n\r\nBefore joining the firm, Asif built and led engineering teams at mission-driven companies including Curri, Joymode, Dollar Shave Club, and Ideum.\r\n",
    socials: {
      linkedin: "https://www.linkedin.com/in/asifhahmed/",
    },
  },
  {
    id: "11",
    name: "Savanna Goodwin",
    position: "Operations Manager",
    text: "Savanna plays a key role in managing firm operations and contributing to the development of successful HR and recruiting strategies both at 776 and across our portfolio companies. She also provides operational support to all 776 incubations. Before joining 776, Savanna helped scale people operations and analytics functions at Reddit.",
    socials: {
      linkedin: "https://www.linkedin.com/in/savanna-goodwin-1a3b2797/",
    },
  },
  {
    id: "12",
    name: "Maggi Comeaux",
    position: "Head of Events & Administration",
    image: MaggiComeaux,
    text: "Maggi brings her passion for hospitality and organizational excellence to her role as Head of Events and Administration. In addition to leading the Seven Seven Six's team of Executive Assistants, Maggi is responsible for the strategy and execution of the firm's yearly events roadmap. She also supports Chris Vanzetta, Partner. Maggi has previously held leader assistant roles and planned events at Frazier Healthcare Partners, Vista Equity Partners, Axcess Worldwide, and VMware.",
    socials: {
      twitter: "https://twitter.com/maggicomeaux",
      linkedin: "https://www.linkedin.com/in/maggicomeaux/",
    },
  },
  {
    id: "13",
    name: "Nefitieri Moncur",
    position: "Executive Assistant to Alexis Ohanian",
    image: NefitieriMoncur,
    text: "Nefitieri brings 15 years of experience building and scaling organizational processes to her role as Executive Assistant to Alexis Ohanian. She fosters cross-functional collaboration, infusing every interaction with a hospitality-first ethos. Prior to joining Seven Seven Six, she lent her expertise as Chief of Staff and administrative lead to esteemed firms including Grayscale Investments, Chainalysis, Oaktree Capital and Finsbury.",
    socials: {
      linkedin: "https://www.linkedin.com/in/nefitieri/",
    },
  },
  {
    id: "14",
    name: "Sarah Boles",
    position: "Executive Assistant to Katelin Holloway",
    image: SarahBoles,
    text: "In addition to supporting Founding Partner Katelin Holloway, Sarah collaborates with our Events team to create memorable experiences for our founders and portfolio companies. She brings over 15 years of administrative experience across a diversity of industries from global logistics to health and wellness. Before joining Seven Seven Six, Sarah supported multiple executives at Flexport.",
    socials: {
      linkedin: "https://www.linkedin.com/in/sarah-boles-94a4366/",
    },
  },
  {
    id: "15",
    name: "Ashraf Shemirani",
    position: "Executive Assistant to Alexis Ohanian",
    image: AshShemirani,
    text: "As an Executive Assistant at the firm, Ashraf supports the partners and Seven Seven Six\u2019s community of founders and our internal team. Before joining the team, Ashraf held administrative roles at WeWork, Sequoia Capital, and Sidewalk Infrastructure Partners.",
    socials: {
      linkedin: "https://www.linkedin.com/in/ashrafshemirani/",
    },
  },
];

export default data;
